'use client';
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    id: 'faq-001',
    q: 'How do I fund my DakaPay wallet?',
    a: 'You can fund your wallet via bank transfer to our dedicated account numbers, using your debit/credit card, or through USSD. Funding is instant and reflected in real time.',
  },
  {
    id: 'faq-002',
    q: 'How long does airtime delivery take?',
    a: 'Airtime is delivered within 5 seconds of a successful transaction. If there is any delay beyond 2 minutes, the transaction is automatically reversed to your wallet.',
  },
  {
    id: 'faq-003',
    q: 'Is DakaPay regulated and secure?',
    a: 'Yes. DakaPay operates under CBN guidelines as a registered fintech platform. We use 256-bit SSL encryption, 2FA, and bank-grade security protocols to protect your funds.',
  },
  {
    id: 'faq-004',
    q: 'What happens if my electricity token is not delivered?',
    a: 'If your DISCO token is not delivered within 3 minutes, we automatically initiate a refund to your wallet. You can also contact our 24/7 support team for immediate resolution.',
  },
  {
    id: 'faq-005',
    q: 'Can I use DakaPay for my business?',
    a: 'Absolutely. Our Business API allows you to integrate airtime, data, and bill payment services into your own platform. Contact our team at api@dakapay.com for documentation.',
  },
  {
    id: 'faq-006',
    q: 'How does the referral program work?',
    a: 'Share your unique referral code with friends. When they sign up and complete their first transaction, you earn ₦200 bonus credited directly to your wallet. No cap on referrals.',
  },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>('faq-001');

  return (
    <section className="py-20 bg-background" id="faq">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="text-accent text-sm font-600 uppercase tracking-widest">FAQ</span>
          <h2 className="text-3xl md:text-4xl font-700 text-primary mt-2 mb-4">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs?.map((faq) => {
            const isOpen = openId === faq?.id;
            return (
              <div key={faq?.id} className={`bg-card rounded-xl border transition-all duration-200 ${isOpen ? 'border-accent/30 shadow-card' : 'border-border'}`}>
                <button
                  onClick={() => setOpenId(isOpen ? null : faq?.id)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left"
                >
                  <span className={`text-sm font-600 ${isOpen ? 'text-primary' : 'text-foreground'}`}>{faq?.q}</span>
                  <ChevronDown
                    size={16}
                    className={`text-muted-foreground shrink-0 ml-4 transition-transform duration-200 ${isOpen ? 'rotate-180 text-accent' : ''}`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-4 animate-fade-in">
                    <p className="text-muted-foreground text-sm leading-relaxed">{faq?.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}